<template>
    <div class="topNav">
        <div class="nav-box">
            <div class="nav-title">
                <!-- <span>中国家庭教育大数据中心</span> -->
                <img class="nav-title-image" src="../../../assets/index/title.png" alt="">
            </div>
            <div class="nav-button">
                <div 
                    :class="item.name === pathName ? 'nav-item nav-item-active' : 'nav-item'" 
                    v-for="(item,index) in nav" 
                    :key="index"
                    @click="changeNav(index)">
                    {{ item.title }}
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
export default {
    name: 'topNav',
    data() {
        return {
            nav: [
                { title: '证书查询', name: 'index', active: true },
                { title: '机构简介', name: 'news', active: false },
                { title: '数说家庭', name: 'numbers', active: false },
                { title: '联系我们', name: 'content', active: false }
            ],
            // 跳转路由的名字
            pathName: 'index'
        }
    },
    methods: {
        changeNav(index) {
            this.nav.map(item => {
                item.active = false
            })
            this.nav[index].active = true
            let name = this.nav[index].name
            this.pathName = name
            this.$router.push({name: name})
        },
        // toMine() {
        //     this.$router.push({name: 'mine'})
        // }
    },
    watch:{
        // // 监听路由变化
        // $route(to){
        //     this.pathName = to.name
        // }
    },

}
</script>

<style lang="less" scoped>
    .topNav {
        width: 100%;
        height: 150px;
        background-color: #fff;
        .nav-box {
            width: 100%;
            padding: 59px 508px 41px 360px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            .nav-title {
                width: 500px;
                .nav-title-image {
                    width: 100%;
                    height: auto;
                }
                // font-size: 36px;
                // font-weight: 500;
                // color: #FCA106;
            }
            .nav-button {
                display: flex;
                margin-top: 16px;
                cursor: pointer;
                .nav-item {
                    font-size: 20px;
                    font-weight: 500;
                    color: #333333;
                    margin-left: 50px;
                }
                .nav-item-active {
                    color: #0091FF;
                }

            }
        }
       
    }
</style>